import BudgetLiderClient from '@/api/BudgetLider/budgetLider.client';

const client = new BudgetLiderClient();

export default {
  namespaced: true,
  state: () => ({
    isLoading: false,
    isSaving: false,
    budgets: [],
    budgetAtual: null,
    supervisores: [],
    representantes: [],
    clientes: [],
    filters: {},
    dashboard: null,
  }),
  getters: {
    budgets: state => state.budgets,
    budgetAtual: state => state.budgetAtual,
    supervisores: state => state.supervisores,
    representantes: state => state.representantes,
    clientes: state => state.clientes,
    isLoading: state => state.isLoading,
    isSaving: state => state.isSaving,
    dashboard: state => state.dashboard,
  },
  mutations: {
    SET_LOADING(state, v) { state.isLoading = v; },
    SET_SAVING(state, v) { state.isSaving = v; },
    SET_BUDGETS(state, v) { state.budgets = v; },
    SET_BUDGET_ATUAL(state, v) { state.budgetAtual = v; },
    SET_SUPERVISORES(state, v) { state.supervisores = v; },
    SET_REPRESENTANTES(state, v) { state.representantes = v; },
    SET_CLIENTES(state, v) { state.clientes = v; },
    SET_FILTERS(state, v) { state.filters = v; },
    SET_DASHBOARD(state, v) { state.dashboard = v; },
  },
  actions: {
    async listar({ commit, state }) {
      commit('SET_LOADING', true);
      try {
        const { data: res } = await client.listar({ ...state.filters });
        commit('SET_BUDGETS', res.data || []);
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async buscarPorId({ commit }, id) {
      commit('SET_LOADING', true);
      try {
        const { data: res } = await client.buscarPorId(id);
        commit('SET_BUDGET_ATUAL', res.data || null);
        return res.data;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async criar({ commit, dispatch }, payload) {
      commit('SET_SAVING', true);
      try {
        const { data: res } = await client.criar(payload);
        await dispatch('listar');
        return res.data;
      } finally {
        commit('SET_SAVING', false);
      }
    },
    async atualizar({ commit, dispatch }, { id, payload }) {
      commit('SET_SAVING', true);
      try {
        const { data: res } = await client.atualizar(id, payload);
        await dispatch('listar');
        return res.data;
      } finally {
        commit('SET_SAVING', false);
      }
    },
    async excluir({ dispatch }, id) {
      await client.excluir(id);
      await dispatch('listar');
    },
    async carregarSupervisores({ commit }) {
      const { data: res } = await client.listarSupervisores();
      commit('SET_SUPERVISORES', res.data || []);
      return res.data;
    },
    async carregarRepresentantes({ commit }, supervisorid) {
      if (!supervisorid) { commit('SET_REPRESENTANTES', []); return []; }
      const { data: res } = await client.listarRepresentantes(supervisorid);
      commit('SET_REPRESENTANTES', res.data || []);
      return res.data;
    },
    // Busca de clientes (autocomplete). Falha silenciosa para não travar o UI.
    async buscarClientes({ commit }, termo) {
      try {
        const { data: res } = await client.buscarClientes(termo);
        commit('SET_CLIENTES', res.data || []);
        return res.data || [];
      } catch (err) {
        commit('SET_CLIENTES', []);
        return [];
      }
    },
    async salvarAlocacoes({ commit }, { id, payload }) {
      commit('SET_SAVING', true);
      try {
        const { data: res } = await client.salvarAlocacoes(id, payload);
        commit('SET_BUDGET_ATUAL', res.data || null);
        return res.data;
      } finally {
        commit('SET_SAVING', false);
      }
    },
    async carregarDashboard({ commit }) {
      commit('SET_LOADING', true);
      try {
        const { data: res } = await client.dashboard();
        commit('SET_DASHBOARD', res.data || null);
        return res.data;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    setFilters({ commit }, filters) { commit('SET_FILTERS', filters); },
  },
};
